export const CreateMailing = () => {
  return <p>Тут будет создание рассылки</p>;
};
